import React, { useMemo, useState, useEffect } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { Check2Circle, XCircle } from "react-bootstrap-icons";
import { Button, Form, Col, Row, Container, Spinner, Alert } from "react-bootstrap";
import API from "../utils/API";
import axios from "axios";
import { useParams, Redirect, useHistory } from "react-router-dom";


export const CheckoutForm = ({ props, paid, depositPaid }) => {
    console.log(depositPaid)
    const [show, setShow] = useState(false);
    const stripe = useStripe();
    const [amt, setAmt] = useState(0.00)
    const { hashid } = useParams();
    const [formFull, setFormFull] = useState(true);
    const [errMsg, setErrMsg] = useState();
    const [paySuccess, setPaySuccess] = useState(false);
    const [paymentSending, setPaymentSending] = useState(false)
    const [paymentSent, setPaymentSent] = useState(false)
    const [cardFull, setCardFull] = useState(false)
    const [desc, setDesc] = useState("general")

    const appearance = {
        theme: 'stripe',

        variables: {
            colorPrimary: '#0570de',
            colorBackground: '#ffffff',
            colorText: '#30313d',
            colorDanger: '#df1b41',
            fontFamily: 'Ideal Sans, system-ui, sans-serif',
            spacingUnit: '2px',
            borderRadius: '15px',
            // See all possible variables below
        }
    };
    const [formObject, setFormObject] = useState({
        clientOrg: "",
        firstName: "",
        lastName: "",
        email: "",
        City: "",
        Phone: "",
        State: "",
        Zip: "",
        Address1: "",
        Address2: "",
        cardType: "",
        cardNumber: "",
        cvc: "",
        expiryDate: "",
        amount: "",
        evntid: "",
    });
    useEffect(() => {
        setFormObject({ ...formObject, evntid: props.__PK_BEO_ID, clientOrg: props.Client_Organization })
    }, [props, paySuccess]);




    function handleInputChange(e) {


        const { name, value } = e.target;
        console.log(name, value)
        // // console.log(typeof meta.cardType.type)
        setFormObject({ ...formObject, [name]: value });
        setErrMsg("");
        checkForm();
    }

    function setAmount(e) {


        // // console.log(formObject.subscription);
        if (parseInt(formObject.subscription) === 1) {
            setFormObject({ ...formObject, amount: "1500.00" });
        } else if (parseInt(formObject.subscription) === 2) {
            setFormObject({ ...formObject, amount: "2700.00" });
        } else if (parseInt(formObject.subscription) === 3) {
            setFormObject({ ...formObject, amount: "3900.00" });
        }
    }

    function checkForm() {

        if (
            formObject.firstName.length > 0 &&
            formObject.lastName.length > 0 &&
            formObject.email.length > 0

        ) {
            console.log("button should show");
            setFormFull(false);
        } else {
            setFormFull(true);

        }
    }



    const options = useMemo(
        () => ({
            theme: 'dark',
            padding: '15px',
            style: {

                base: {

                    iconColor: '#8c8c8c',
                    color: '#212529',
                    fontWeight: '300',
                    fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
                    fontSize: '20px',
                    fontSmoothing: 'antialiased',
                    ':-webkit-autofill': {
                        color: '#fce883',
                    },
                    '::placeholder': {
                        color: '#212529',
                    },

                }
            }
        }),

    );


    const elements = useElements(appearance);
    function checkCard(e) {

        // console.log(e)
        if (e.complete === true) {
            setCardFull(true)
        }
        else {
            setCardFull(false)
        }

    }


    function HandleAmountSelect(e) {
        console.log(e.target.id)
        if (e.target.id !== 'balance' && document.getElementById("balance").checked === true) {
            // console.log("balace false")
            document.getElementById("balance").checked = false;
            console.log(e.target.value)
        }
        if (e.target.id === 'balance' && document.getElementById("balance").checked) {
            let checks = document.getElementsByTagName('input')
            // console.log(checks.length)
            setAmt(e.target.value)
            for (let i = 0; i < checks.length; i++) {

                // console.log(checks[i].type)
                if (checks[i].type === "checkbox" && checks[i].id !== 'balance') {
                    document.getElementById(checks[i].id).checked = false
                }
            }
        } else {
            console.log(e.target.id)
            console.log(e.target.value)
            if (e.target.id === 'other') {
                setAmt(0.00)
            }
            if (e.target.id === 'custAmount') {
                document.getElementById('other').checked = true

                let dol = e.target.value.replace(/(\.\d{2}).+/g, '$1')

                setAmt(dol)
            }
            if (e.target.id === 'Deposit') {
                document.getElementById('Deposit').checked = true

                let dol = e.target.value.replace(/(\.\d{2}).+/g, '$1')
                setDesc("Deposit")
                setAmt(dol)
            }
        }
    }


    const handleSubmit = async (event) => {
        event.preventDefault();
        console.log(desc)
        if (amt > props.Balance) {
            console.log("you are paying more than owed")
            setShow(true)

        } else {
            console.log("sending payment")
            const { error, paymentMethod } = await stripe.createPaymentMethod({
                type: "card",
                card: elements.getElement(CardElement),
            });

            if (!error) {
                console.log("Stripe 23 | token generated!", paymentMethod);
                setErrMsg()
                try {

                    setPaymentSending(true)
                    const { id } = paymentMethod;
                    const response = await axios.post(
                        `/api/${hashid}/payment`,
                        {
                            amount:  (parseFloat(amt)),
                            id: id,
                            form: formObject,
                            type: desc,
                            recID: props.recordID
                        }
                    );

                    console.log("Stripe 35 | data", response.data.success);
                    if (response.data.success) {
                        console.log("CheckoutForm.js 25 | payment successful!");
                        setPaySuccess(true)
                        paid(true)
                        setPaymentSent(true)
                        setPaymentSending(false)
                    } else {
                        console.log(response.data)
                        setErrMsg(response.data.reason)
                        setPaySuccess(false)
                        setPaymentSent(true)
                        setPaymentSending(false)
                    }
                } catch (error) {
                    console.log("CheckoutForm.js 28 | ", error);
                    setPaymentSending(false)
                    setPaymentSent(true)
                    setPaySuccess(false)
                    setErrMsg(error)
                }
            } else {
                setErrMsg(error.message)

                // console.log(error.message);
            }
        }


    };
    function handleAP(e) {
        setPaymentSending(false)
        setPaymentSent(false)
        setPaySuccess(false)
        setAmt(0.00)
    }

    return (
        <Container className="align-items-center">
            <h4 className="text-light text-center">There is a total of ${props.Balance.toFixed(2)} remaining.</h4>
            {paymentSent ? (<>
                {paySuccess ? (
                    <Container>
                        <div className="text-center text-light m-3">
                            <h1>Payment Successful!</h1>
                            <Check2Circle
                                style={{ fontSize: "10vh", color: "white", width: "10vh" }}
                            />
                        </div>
                        <Button onClick={(e) => handleAP(e)}> Make another Payment</Button>
                    </Container>) : (<Container>
                        <div className="text-center text-light m-3">
                            <h1>Payment Failed!</h1>
                            <XCircle
                                style={{ fontSize: "10vh", color: "crimson", width: "10vh" }}
                            />
                            <p>{errMsg}</p>
                        </div>
                        <Button variant="danger" onClick={(e) => handleAP(e)}> Try Again</Button>
                    </Container>)}
            </>
            ) : (
                <>
                    {paymentSending ? (<div> <h3> Payment is processing...</h3> <Spinner animation="grow" variant="danger" /></div>) : (

                        <>

                            <Row className="align-top m-auto ">
                                <div className="ingru">
                                    <input className="checkmark " type="checkbox" id="balance" name="balance" value={props.Balance.toFixed(2)} onChange={(e) => HandleAmountSelect(e)} />
                                    <label className="checklable float-start " for="balance">Balance: ${props.Balance.toFixed(2)}</label>
                                </div>
                            </Row>
                            {props.DepositPaid ? (<Row className=" ">

                                <div className="ingru2">

                                    <input className="checkmark  " type="checkbox" id="other" name="other" onChange={(e) => HandleAmountSelect(e)} />
                                    <label className="checklable" for="other">Other Amount: </label>
                                    <input id="custAmount" type="number" min="0.00" max="99999.99" step="0.01" patter="/^\d+\.?\d{0,2}/" width={1} onChange={(e) => HandleAmountSelect(e)}></input>
                                </div>
                            </Row>) : (<Row className=" ">
                                <div className="ingru">
                               { isNaN(parseFloat(props.Deposit).toFixed(2))  ? 'Deposit Not Set' : 
                               
                              <> <input className="checkmark  " type="checkbox" id="Deposit" name="Deposit" value={parseFloat(props.Deposit).toFixed(2)} onChange={(e) => HandleAmountSelect(e)} />
                              <label className="checklable float-start " for="Deposit">Deposit: ${parseFloat(props.Deposit).toFixed(2)}</label></>
                               }
                                   
                                </div>
                            </Row>)}




                            {/* {
                            contractData.eventPayments ? (<>
                                {contractData.eventPayments.map((item) =>
                                    item["EventPayments::IsPaid"] !== 1 && item["EventPayments::RequestedPaymentsAmount"] > 0 ? (
                                        <Row>
                                            <Col xs md="5" className="pt-1">       <input className="checkmark float-end" type="checkbox" id={item["EventPayments::PrimaryKey"]} name="paymentrequest" value={item["EventPayments::RequestedPaymentsAmount"]} onChange={(e) => HandleAmountSelect(e)} /></Col>
                                            <Col md="auto">            <label class="checklable" for="paymentrequest">{item["EventPayments::Descripton"]}: ${item["EventPayments::RequestedPaymentsAmount"]}</label></Col>
                                        </Row>
                                    )
                                        : ("")
                                )}
                            </>
                            ) : ("dxsfghsdhg")
                        } */}


                            <Row className="justify-content-md-center">
                                <Form onSubmit={(e) => handleSubmit(e)} onBlur={(e) => checkForm(e)} className="text-light">

                                    <Row className="justify-content-md-center">
                                        <Form.Group as={Col} md="4" sm="12" controlId="validationCustom01">
                                            <Form.Label>First name</Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                placeholder="First Name"
                                                name="firstName"
                                                onChange={(e) => handleInputChange(e)}
                                            />
                                            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group as={Col} md="4" sm="12" controlId="validationCustom02">
                                            <Form.Label>Last name</Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                placeholder="Last Name"
                                                name="lastName"
                                                onChange={(e) => handleInputChange(e)}
                                            />
                                            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                        </Form.Group>
                                    </Row>
                                    <Row className="justify-content-md-center">

                                        <Form.Group as={Col} md="4" sm="12" controlId="validationCustom07">
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control
                                                type="email"
                                                placeholder="Email"
                                                required
                                                name="email"
                                                onChange={(e) => handleInputChange(e)}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please provide a valid Email.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group as={Col} md="4" sm="12" controlId="validationCustom07">
                                            <Form.Label>Phone Number</Form.Label>
                                            <Form.Control
                                                type="phone"
                                                pattern="[+ 0-9]{10}"
                                                placeholder="Phone"
                                                required
                                                name="Phone"
                                                onChange={(e) => handleInputChange(e)}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please provide a valid phone number.
                                            </Form.Control.Feedback>
                                        </Form.Group>


                                    </Row >
                                    <Row className="mt-3  justify-content-md-center">

                                        <Form.Group as={Col} md="8" sm="12" required>


                                            <CardElement options={options} id="payment-form" onChange={(e) => checkCard(e)} />


                                        </Form.Group>


                                    </Row>
                                    <Row className="justify-content-md-center">
                                        {show ? (
                                            <Row className="justify-content-md-center">
                                                <Col md="8" sm="12">
                                                    <Alert className="m-2" variant="danger" onClose={() => setShow(false)} dismissible>
                                                        <Alert.Heading>Your amount is too high!</Alert.Heading>
                                                        <p>
                                                            You are trying to pay more than you owe. <br /> Please lower the amount or select "Balance".
                                                        </p>
                                                    </Alert>
                                                </Col>
                                            </Row>
                                        ) : ("")}

                                        <Button
                                            variant="danger"
                                            style={{ width: '150px' }}
                                            className="m-2 "
                                            type="submit"
                                            disabled={!formFull && cardFull && amt >= 1 ? false : true}
                                        >
                                            {amt < 1 ? ("Select Amount") : ("Pay  $" + amt)}

                                        </Button>
                                    </Row>
                                </Form >



                            </Row>
                        </>)
                    }
                </>


            )}


        </Container >
    );
};